module.exports = __webpack_public_path__ + "img/hana_006.953f4ed2.jpg";